"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateICNSName = exports.parseICNSName = void 0;
function parseICNSName(name) {
    const split = name.split(".");
    if (split.length === 2) {
        if (split[0].length > 0 && split[1].length > 0) {
            return [split[0], split[1]];
        }
    }
    return undefined;
}
exports.parseICNSName = parseICNSName;
function validateICNSName(name, bech32Prefix) {
    const parsed = parseICNSName(name);
    if (!parsed) {
        return false;
    }
    return parsed[1] === bech32Prefix;
}
exports.validateICNSName = validateICNSName;
//# sourceMappingURL=index.js.map